import BaseClient from './baseClient';
import { getAccessTokenFromLocalStorage } from '../utils/authHelpers';

type ProductRankingReqParams = {
  marketplace: string;
  language: string;
  channelId: string;
  searchTerms: string;
  searchOptions?: string;
  navigationType?: string;
  explain?: boolean;
  productIdList?: string[];
};

export type ProductRankingResult = {
  searchTerm?: string;
  productList?: unknown[];
  explain?: {
    ruleInfo?: {
      _id?: string;
      name?: string;
    };
  };
};

class ProductRankingClient extends BaseClient {
  getDefaultHeaders() {
    return {
      Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
      'Content-Type': 'application/json',
    };
  }

  async ranking(
    params: ProductRankingReqParams,
  ): Promise<ProductRankingResult> {
    const res: ProductRankingResult = await this.fetch(
      '/proxy/search/productranking/v1/ranking',
      {
        method: 'POST',
        headers: this.getDefaultHeaders(),
        body: JSON.stringify(params),
      },
    );
    return res;
  }
}

export default new ProductRankingClient();
